module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.preferences), function(preference) {
    return _c('fieldset', {
      key: preference.id
    }, [_c('input-checkbox', {
      attrs: {
        "label": preference.description,
        "value": preference.checked
      },
      on: {
        "change": function($event) {
          _vm.togglePreference(preference)
        }
      }
    })], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4617f52","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketingPreferences.vue
// module id = 616
// module chunks = 0